import { Port } from '@app/models';
import { Action } from '@ngrx/store';

export enum PortActionTypes {
  Load = '[API] Load ports',
  LoadSuccess = '[API] Load ports success',
  LoadFail = '[API] Load ports fail',
  AddAll = '[Port] Add all',
  Create = '[API] Create port ',
  CreateSuccess = '[API] Create port success',
  CreateFail = '[API] Create port fail',
  AddOne = '[Port] Add one',
  Update = '[API] Update port ',
  UpdateSuccess = '[Port] Update port success',
  UpdateFail = '[Port] Update port fail',
  UpdateOne = '[Port] Update one',
  Delete = '[API] Delete port ',
  DeleteSuccess = '[Port]  Delete port success',
  DeleteFail = '[Port]  Delete port fail',
  Export = '[API] export port',
  ExportSuccess = '[API] export port success',
  ExportFail = '[API] export port fail',
  UploadProcessPending = "[API] upload process pending",
  UploadProcessSuccess = "[API] upload process success",
}

export class Load implements Action {
  readonly type = PortActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = PortActionTypes.LoadSuccess;
  constructor(public ports: Port[]) {}
}

export class LoadFail implements Action {
  readonly type = PortActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class UploadProcessPending implements Action {
  readonly type = PortActionTypes.UploadProcessPending;
  constructor(public data?: any){}
}

export class UploadProcessSuccess implements Action {
  readonly type = PortActionTypes.UploadProcessSuccess;
  constructor(){}
}

export class AddAll implements Action {
  readonly type = PortActionTypes.AddAll;
  constructor(public ports: Port[]) {}
}

export class Create implements Action {
  readonly type = PortActionTypes.Create;
  constructor(public ports: Port) {}
}

export class CreateSuccess implements Action {
  readonly type = PortActionTypes.CreateSuccess;
  constructor(public ports: Port) {}
}

export class CreateFail implements Action {
  readonly type = PortActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = PortActionTypes.AddOne;
  constructor(public port: Port) {}
}

export class Delete implements Action {
  readonly type = PortActionTypes.Delete;
  constructor(public id: number) {}
}
export class DeleteFail implements Action {
  readonly type = PortActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export class DeleteSuccess implements Action {
  readonly type = PortActionTypes.DeleteSuccess;
  constructor(public id: number) {}
}

export class Update implements Action {
  readonly type = PortActionTypes.Update;
  constructor(public id: number, public port: any) {}
}
export class UpdateFail implements Action {
  readonly type = PortActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = PortActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateOne implements Action {
  readonly type = PortActionTypes.UpdateOne;
  constructor(public port: Port) {}
}

export class Export implements Action {
  readonly type = PortActionTypes.Export;
  constructor() {}
}

export class ExportSuccess implements Action {
  readonly type = PortActionTypes.ExportSuccess;
  constructor() {}
}

export class ExportFail implements Action {
  readonly type = PortActionTypes.ExportFail;
  constructor(public error: any) {}
}

export type PortActionsUnion =
  | Load
  | LoadFail
  | LoadSuccess
  | AddAll
  | Create
  | CreateSuccess
  | CreateFail
  | AddOne
  | Delete
  | DeleteFail
  | DeleteSuccess
  | Update
  | UpdateFail
  | UpdateSuccess
  | UpdateOne
  | Export
  | ExportSuccess
  | ExportFail
  | UploadProcessPending
  | UploadProcessSuccess;
